import { useLocation } from "react-router-dom";
import { ExternalLink, Menu } from "lucide-react";

const PAGE_TITLES: Record<string, string> = {
  "/admin": "Dashboard",
  "/admin/calendar": "Occupancy Calendar",
  "/admin/bookings": "Bookings",
  "/admin/rooms": "Rooms",
  "/admin/rooms/types": "Room Types",
  "/admin/guests": "Guests",
  "/admin/enquiries": "Enquiries",
  "/admin/content": "Content",
  "/admin/reports": "Reports",
  "/admin/settings": "Settings",
};

interface AdminTopbarProps {
  onMenuClick: () => void;
}

export default function AdminTopbar({ onMenuClick }: AdminTopbarProps) {
  const { pathname } = useLocation();
  const title = PAGE_TITLES[pathname] ?? "Admin";

  return (
    <header className="flex h-16 shrink-0 items-center justify-between border-b border-gray-100 bg-white px-4 md:px-6">
      <div className="flex items-center gap-3">
        {/* Hamburger — mobile only */}
        <button
          type="button"
          onClick={onMenuClick}
          aria-label="Open menu"
          className="flex h-8 w-8 items-center justify-center rounded-md text-metro-ink-subtle transition hover:bg-gray-100 hover:text-metro-ink lg:hidden"
        >
          <Menu size={20} />
        </button>
        <h1 className="font-serif text-xl text-metro-green-950">{title}</h1>
      </div>

      <div className="flex items-center gap-3">
        <a
          href="/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium text-metro-ink-subtle transition hover:bg-metro-green-50 hover:text-metro-green-800"
        >
          <ExternalLink size={13} />
          <span className="hidden sm:inline">View site</span>
        </a>
      </div>
    </header>
  );
}